import React from 'react';
import Header1 from '../components/Header1'; // Adjust the path if necessary
import Footer from '../components/Footer'; // Adjust the path if necessary
import './Solutions.css';

const Solutions = () => {
    return (
        <>
            <Header1 />
            
            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
                    <h1>Our Solutions</h1>
                    <p>Tailored solutions for individuals, businesses, and enterprises.</p>
                </div>
            </section>

            {/* Main Content */}
            <div className="solutions-page">
                {/* For Individuals Section */}
                <section className="solutions-section">
                    <div className="solutions-container">
                        <h2>For Individuals</h2>
                        <p>
                            Our professional plan is perfect for individuals looking to make a strong impression.
                            It offers:
                        </p>
                        <ul>
                            <li>Cut costs associated with printing and distributing physical business cards.</li>
                            <li>Reduce your carbon footprint by going paperless.</li>
                            <li>Increased limit of 5 digital business cards.</li>
                            <li>Access to detailed analytics to track your networking efforts.</li>
                        </ul>
                    </div>
                </section>

                {/* For Business Section */}
                <section className="solutions-section">
                    <div className="solutions-container">
                        <h2>For Business</h2>
                        <p>
                            Transition your business to a fully digital and contactless solution:
                        </p>
                        <ul>
                            <li>Cut costs associated with printing and distributing physical business cards.</li>
                            <li>Reduce your carbon footprint by going paperless.</li>
                            <li>Corporate contact book with Hubspot integration for seamless management of your team’s connections.</li>
                            <li>Administrative control to manage team permissions and access.</li>
                            <li>Create company card templates to maintain consistent corporate branding.</li>
                            <li>Access to detailed analytics to monitor and optimize your business connections.</li>
                        </ul>
                    </div>
                </section>

                {/* For Enterprise Section */}
                <section className="solutions-section">
                    <div className="solutions-container">
                        <h2>For Enterprise</h2>
                        <p>
                            Enterprise-level solutions for large organizations needing advanced features:
                        </p>
                        <ul>
                            <li>All the benefits of the Business plan, plus:</li>
                            <li>Bulk updates to digital business cards for large teams.</li>
                            <li>High-level security to protect your business data.</li>
                            <li>Dedicated account manager with onboarding support.</li>
                        </ul>
                    </div>
                </section>
            </div>
            
            <Footer />
        </>
    );
};

export default Solutions;
